const Footer = () => {
    return (
        <footer>
            <>
                <img src="/powered-by-strava.png" alt="Powered by Strava" style={{height:"35px"}}/>
                <p id="footer-text">❤️Made during naptime by <a href="https://github.com/aligg" target="_blank" rel="noreferrer">aligg</a>
                </p>
            </>
        </footer>
    )
}

export default Footer;